<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    @change="setRouteId"
    :label="$t('routes')"
    item-text="name"
    item-value="id"
    prepend-icon="mdi-map lime--text"
    dense
    filled
    hide-details
    solo-inverted
    clearable
  ></v-autocomplete>
</template>
<script>
export default {
  name: "components-common-filter-autocomplete-routes",
  data: () => ({
    select: null,
    isLoading: false,
    items: [],
    search: null,
    endpoint: "",
    level: "",
  }),
  async created() {
    // ====================================================
    // 1. Config Endpoint:
    this.level = localStorage.getItem("level");

    if (this.level == "collaborator") {
      this.level = "collab";
    }

    this.endpoint = `${this.level}/routes/list`;

    // ====================================================
    // 2. Request If Level Regional Manager
    if (this.level == "regionalManager") {
      this.getRoutesList();
    }
  },
  computed: {
    enableAutocompleteRoutes() {
      return this.$store.state.filters.autocompleteRoutes.enable;
    },
    // ====================================================
    // 2. IF - Administrator (Setup Id Regional)
    id_regional() {
      if (this.level == "administrator") {
        return this.$store.state.filters.autocompleteRegionals.id;
      }
      return null;
    },
  },
  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;
      // Items have already been requested
      if (this.isLoading) return;
      // Request
      this.getRoutesList();
    },
    // ====================================================
    // 3. IF - Administrator
    id_regional(val) {
      if (this.enableAutocompleteRoutes) {
        val && this.getRoutesList();
      }
    },
    // Observar a "troca de rota" ou o array de "items",
    // e se caso existir o id_regional na url (query ou params),
    // filtrar o item, exibir no select e setRouteId no store:
    items() {
      this.selectRouteByQueryOrParams();
    },
    $route() {
      this.selectRouteByQueryOrParams();
    },
  },
  methods: {
    setRouteId(id) {
      this.$store.commit("setRouteId", id ? id : "");
    },

    async getRoutesList() {
      this.isLoading = true;
      try {
        const response = await this.$request.post(this.endpoint, {
          // if - administrator level follow:
          id_regional: this.id_regional,
        });
        if (response.length == 0) {
          this.items = [];
          return;
        }

        this.items = response.dados.map((item) => ({
          name: `${item.nome} (${item.id})`,
          id: item.id,
          id_regional: item.id_regional,
        }));
      } finally {
        this.isLoading = false;
      }
    },

    selectRouteByQueryOrParams() {
      let select;

      if (this.$route.query.id_regional) {
        select = this.items.filter(
          (item) => item.id_regional == this.$route.query.id_regional
        );
      }

      if (!this.$route.query.id_regional) {
        return;
      }

      if (select[0] == undefined) return;
      this.select = select[0];
      this.setRouteId(this.select.id);
    },
  },
};
</script>
